module.exports = __webpack_public_path__ + "img/nav-reseller-icon.41ed74ef.svg";